export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_4W_44_1W_4_15',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_44_1w_4_15_usd',
			EUR: 'simple_premium_4w_39_1w_4_15_eur',
			GBP: 'simple_premium_4w_44_1w_4_15_gbp',
			AUD: 'simple_premium_4w_73_1w_6_39_aud',
			CAD: 'simple_premium_4w_73_1w_6_39_cad',
			DKK: 'simple_premium_4w_379_1w_31_2_dkk',
			SEK: 'simple_premium_4w_585_1w_47_2_sek',
			NOK: 'simple_premium_4w_585_1w_47_2_nok',
			BRL: 'simple_premium_4w_99_1w_13_6_brl',
			MXN: 'simple_premium_4w_729_1w_63_2_mxn',
			TRY: 'simple_premium_4w_1499_1w_135_2_try',
			ARS: 'simple_premium_4w_58000_1w_5592_ars',
			COP: 'simple_premium_4w_178000_1w_16792_cop',
			CLP: 'simple_premium_4w_42000_1w_3992_clp',
		},
		primer: 'prd_LeLj4VgRBpgS',
	},
}
